import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import { CloseCircle } from 'iconsax-react';
import { PrimaryButon } from '../../../../../components/common/button/PrimaryButon';
import { QTextArea } from '../../../../../components/common/inputs/QTextArea';
import { WidgetHeader } from '@ui/components/common/header/widgetHeader/WidgetHeader';
export const DiclinedDialog = ({ open, handleClose, onConfirm }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState(false);
    const handleDialogClose = () => {
        setReason('');
        setError(false);
        handleClose();
    };
    const handleConfirm = () => {
        if (!reason.trim()) {
            setError(true);
            return;
        }
        setError(false);
        onConfirm(reason);
        handleDialogClose();
    };
    return (_jsxs(Dialog, { open: open, onClose: handleDialogClose, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        }, children: [_jsxs(WidgetHeader, { background: 'white', children: [_jsx(Typography, { variant: 'h5', textAlign: 'center', color: 'black', children: "Decline hours" }), _jsx(IconButton, { children: _jsx(CloseCircle, { onClick: handleDialogClose, style: { color: 'black' } }) })] }), _jsx(Box, { width: 700, overflow: "hidden", children: _jsxs(Box, { sx: {
                        padding: '10px 25px 25px 25px',
                        background: 'white',
                        borderBottomRightRadius: '25px',
                        borderBottomLeftRadius: '25px',
                        overflow: "hidden",
                    }, children: [_jsx(Typography, { variant: 'subtitle2', mb: 1, color: 'initial', children: "Reason why hours got declined" }), _jsx(QTextArea, { rows: 10, bgColor: 'white', value: reason, onChange: (e) => {
                                setReason(e);
                                if (e !== '')
                                    setError(false);
                                else
                                    setError(true);
                            } }), error && (_jsx(Typography, { variant: 'caption', fontWeight: 500, ml: 2, color: '#FF0000', children: 'This field is required' })), _jsx(Box, { width: '350px', margin: 'auto', children: _jsx(PrimaryButon, { mt: 25, onClick: handleConfirm, children: "Decline and send reason to user" }) })] }) })] }));
};
